import createReducer from '../../utils/createReducer';
import {
  GET_EMPLOYMENT_STATUS_LIST_SUCCESS,
  GET_EMPLOYMENT_STATUS_LIST_ERROR,
  GET_OCCUPATION_CATEGORIES_SUCCESS,
  GET_OCCUPATION_CATEGORIES_ERROR,
  GET_OCCUPATION_CATEGORY_INFO_SUCCESS,
  GET_OCCUPATION_CATEGORY_INFO_ERROR,
  GET_EMPLOYMENT_INFO_SUCCESS,
  GET_EMPLOYMENT_INFO_ERROR,
  CREATE_EMPLOYMENT_INFO_SUCCESS,
  CREATE_EMPLOYMENT_INFO_ERROR,
  UPDATE_EMPLOYMENT_INFO_SUCCESS,
  UPDATE_EMPLOYMENT_INFO_ERROR,
  GET_INCOME_SOURCE_LIST_SUCCESS,
  GET_INCOME_SOURCE_LIST_ERROR,
} from '../../actions/employmentStatus/employmentStatusActionConstants';

const initialState = {
  EmploymentStatusList: [],
  OccupationCategories: [],
  OccupationCategory: {},
  EmploymentInfo: {},
  IncomeSourceList: [],
  error: '',
};

export default createReducer(
  {
    [GET_EMPLOYMENT_STATUS_LIST_SUCCESS]: fetchEmploymentStatusList,
    [GET_EMPLOYMENT_STATUS_LIST_ERROR]: fetchEmploymentStatusListError,
    [GET_OCCUPATION_CATEGORIES_SUCCESS]: fetchOccupationCategories,
    [GET_OCCUPATION_CATEGORIES_ERROR]: fetchOccupationCategoriesError,
    [GET_OCCUPATION_CATEGORY_INFO_SUCCESS]: fetchOccupationCategory,
    [GET_OCCUPATION_CATEGORY_INFO_ERROR]: fetchOccupationCategoryError,
    [GET_EMPLOYMENT_INFO_SUCCESS]: fetchEmploymentInfo,
    [GET_EMPLOYMENT_INFO_ERROR]: fetchEmploymentInfoError,
    [CREATE_EMPLOYMENT_INFO_SUCCESS]: createEmploymentInfo,
    [CREATE_EMPLOYMENT_INFO_ERROR]: createEmploymentInfoError,
    [UPDATE_EMPLOYMENT_INFO_SUCCESS]: updateEmploymentInfo,
    [UPDATE_EMPLOYMENT_INFO_ERROR]: updateEmploymentInfoError,
    [GET_INCOME_SOURCE_LIST_SUCCESS]: fetchIncomeSourceList,
    [GET_INCOME_SOURCE_LIST_ERROR]: fetchIncomeSourceListError,
  },
  initialState,
);

function fetchEmploymentStatusList(state, { payload }) {
  return {
    ...state,
    EmploymentStatusList: payload,
    error: '',
  };
}

function fetchEmploymentStatusListError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function fetchOccupationCategories(state, { payload }) {
  return {
    ...state,
    OccupationCategories: payload,
    error: '',
  };
}

function fetchOccupationCategoriesError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function fetchOccupationCategory(state, { payload }) {
  return {
    ...state,
    OcupationCategory: payload,
    error: '',
  };
}

function fetchOccupationCategoryError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function fetchEmploymentInfo(state, { payload }) {
  return {
    ...state,
    EmploymentInfo: payload,
    error: '',
  };
}

function fetchEmploymentInfoError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function createEmploymentInfo(state, { payload }) {
  return {
    ...state,
    EmploymentInfo: payload,
    error: '',
  };
}

function createEmploymentInfoError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function updateEmploymentInfo(state, { payload }) {
  return {
    ...state,
    EmploymentInfo: payload,
    error: '',
  };
}

function updateEmploymentInfoError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function fetchIncomeSourceList(state, { payload }) {
  return {
    ...state,
    IncomeSourceList: payload,
    error: '',
  };
}

function fetchIncomeSourceListError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}
